export default {
  data () {
    return {
      colDragEvent: {
        dragging: false,
        mouseXStart: 0,
        startWidth: 0,
        index: 0
      },
      colGroupRefs: [] // you need to append the table header colgroup and body colgroup here on mounted
    }
  },
  methods: {
    mouseUp (index) {
      this.colDragEvent.dragging = false
      this.colDragEvent.index = null
    },
    onMouseMove (e) {
      if (this.colDragEvent.dragging) {
        var distance = this.colDragEvent.startWidth + (e.pageX - this.colDragEvent.startX)
        if (distance < 20) { // minimum cell width (should be positive)
          distance = 20
        }
        for (var ref of this.colGroupRefs) {
          ref.children[this.colDragEvent.index].style.width = distance + 'px'
        }
      }
    },
    startColDrag (index, event) {
      this.colDragEvent.startWidth = event.target.parentElement.offsetWidth
      this.colDragEvent.startX = event.clientX
      this.colDragEvent.dragging = true
      this.colDragEvent.index = index
    }
  }
  /* mounted () {
    // EXAMPLE mounted. You need to add this manually to each component
    this.colGroupRefs.push(this.$refs.colgroup1, this.$refs.colgroup2)
    window.addEventListener('mousemove', this.onMouseMove)
    window.addEventListener('mouseup', this.mouseUp)
  } */
}
